module.exports = __webpack_public_path__ + "img/delete_icon.b1e1a94b.svg";